import React, { Component } from "react";
import { Row, Col, Tag, Collapse, Button } from "antd";

import "./styles.css";

const Panel = Collapse.Panel;
const CheckableTag = Tag.CheckableTag;

const plainOptions = {
  rarity: ["Basic", "Special", "Rare", "Super Rare", "Uber Super Rare"],
  form: ["Normal", "Evolved", "True"],
  target: ["Red", "Black", "Floating", "Metal", "Angel", "Alien", "Zombie"],
  type: ["Single Attack", "Area Attack"],
  ability: [
    "Weakens",
    "Freeze",
    "Slow",
    "Attacks Only",
    "Strong Against",
    "Resistant",
    "Massive Damage",
    "Knockback",
    "Strengthen",
    "Survive",
    "Base Destroyer",
    "Critical",
    "Zombie Killer",
    "Barrier Breaker",
    "Extra Money",
    "Metal",
    "Wave Attack",
    "Resist Weaken",
    "Resist Freeze",
    "Resist Slow",
    "Resist Knockback",
    "Unharmed by Waves",
    "Warp Blocker",
    "Resist Curse",
    "Wave Shield",
    "Long Distance",
    "Omni Strike",
  ],
};

class HotTags extends Component {
  constructor(props) {
    super(props);
    this.state = {
      rarity: [],
      form: [],
      target: [],
      type: [],
      ability: [],
    };
  }

  handleChange(tag, checked, name) {
    // console.log(name);
    const selectedTags = this.state[name];

    const nextSelectedTags = checked
      ? [...selectedTags, tag]
      : selectedTags.filter((t) => t !== tag);
    // console.log("You are interested in: ", nextSelectedTags);
    this.setState({ [name]: nextSelectedTags }, function () {
      // console.log("rarity: ", this.state.rarity);
      // console.log("form: ", this.state.form);
      // console.log("target: ", this.state.target);
      // console.log("atk type: ", this.state.type);
      // console.log("ability: ", this.state.ability);
      console.log(this.state);
    });
  }

  onClearAllChange = (e) => {
    console.log("onClearAllChange clicked.");
    this.setState(
      {
        // rarity: e.target.checked ? plainOptions.rarity : [],
        // form: e.target.checked ? plainOptions.form : [],
        // target: e.target.checked ? plainOptions.target : [],
        // ability: e.target.checked ? plainOptions.ability : []
        rarity: [],
        form: [],
        target: [],
        type: [],
        ability: [],
      },
      function () {
        console.log("rarity: ", this.state.rarity);
        console.log("form: ", this.state.form);
        console.log("target: ", this.state.target);
        console.log("atk type: ", this.state.type);
        console.log("ability: ", this.state.ability);
      }
    );
  };

  render() {
    const clearBtn = (
      <Button
        size="small"
        onClick={this.onClearAllChange}
        style={{
          float: "right",
          margin: "0 8px 0 0",
        }}
        className="mobile-hide"
      >
        Clear All
      </Button>
    );

    const FilterHeader = (
      <div>
        Filter
        {clearBtn}
      </div>
    );

    const mobileClearBtn = (
      <Button
        // size="medium"
        onClick={this.onClearAllChange}
        style={{
          margin: "0 0 0 -8px",
        }}
      >
        Clear All
      </Button>
    );

    const mobileApplyBtn = (
      <Button
        // size="medium"
        // onClick={this.onClearAllChange}
        style={{
          margin: "0 0 0 -6px",
        }}
      >
        Apply
      </Button>
    );

    const mobileFilterFooter = (
      <Row>
        <Col span={12} style={{ textAlign: "center" }}>
          {mobileClearBtn}
        </Col>
        <Col span={12} style={{ textAlign: "center" }}>
          {mobileApplyBtn}
        </Col>
      </Row>
    );

    return (
      <div className="filter">
        <Collapse
          defaultActiveKey={["1", "2", "3", "4", "5"]}
          onChange={this.callback}
        >
          <Panel
            disabled={true}
            showArrow={false}
            header={FilterHeader}
            key="6"
          />

          <Panel header="Rarity" key="1">
            {plainOptions.rarity.map((tag) => (
              <Row key={tag} style={{ padding: "3px 0 3px 0" }}>
                <CheckableTag
                  key={tag}
                  name="rarity"
                  checked={this.state.rarity.indexOf(tag) > -1}
                  onChange={(checked) =>
                    this.handleChange(tag, checked, "rarity")
                  }
                >
                  {tag}
                </CheckableTag>
              </Row>
            ))}
          </Panel>
          <Panel header="Form" key="2">
            {plainOptions.form.map((tag) => (
              <Row key={tag} style={{ padding: "3px 0 3px 0" }}>
                <CheckableTag
                  key={tag}
                  name="form"
                  checked={this.state.form.indexOf(tag) > -1}
                  onChange={(checked) =>
                    this.handleChange(tag, checked, "form")
                  }
                >
                  {tag}
                </CheckableTag>
              </Row>
            ))}
          </Panel>
          <Panel header="Target" key="3">
            {plainOptions.target.map((tag) => (
              <Row key={tag} style={{ padding: "3px 0 3px 0" }}>
                <CheckableTag
                  key={tag}
                  color="gold"
                  name="target"
                  checked={this.state.target.indexOf(tag) > -1}
                  onChange={(checked) =>
                    this.handleChange(tag, checked, "target")
                  }
                >
                  {tag}
                </CheckableTag>
              </Row>
            ))}
          </Panel>
          <Panel header="Attack Type" key="4">
            {plainOptions.type.map((tag) => (
              <Row key={tag} style={{ padding: "3px 0 3px 0" }}>
                <CheckableTag
                  key={tag}
                  color="gold"
                  name="type"
                  checked={this.state.type.indexOf(tag) > -1}
                  onChange={(checked) =>
                    this.handleChange(tag, checked, "type")
                  }
                >
                  {tag}
                </CheckableTag>
              </Row>
            ))}
          </Panel>
          <Panel header="Ability" key="5">
            {plainOptions.ability.map((tag) => (
              <Row key={tag} style={{ padding: "3px 0 3px 0" }}>
                <CheckableTag
                  key={tag}
                  name="ability"
                  checked={this.state.ability.indexOf(tag) > -1}
                  onChange={(checked) =>
                    this.handleChange(tag, checked, "ability")
                  }
                >
                  {tag}
                </CheckableTag>
              </Row>
            ))}
          </Panel>
          <Panel
            disabled={true}
            showArrow={false}
            header={mobileFilterFooter}
            key="7"
            className="mobile-show"
          />
        </Collapse>
      </div>
    );
  }
}

export default HotTags;



// WEBPACK FOOTER //
// ./src/components/tag/Tag.js